// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManualTimeAddition-module__font-s-10___RnjAl {
  font-size: 10px !important;
}

.ManualTimeAddition-module__font-s-12___C0yXL {
  font-size: 12px !important;
}

.ManualTimeAddition-module__font-s-13___z04K4 {
  font-size: 13px !important;
}

.ManualTimeAddition-module__font-s-14___gs5Ge {
  font-size: 14px !important;
}

.ManualTimeAddition-module__font-s-15___QpJNi {
  font-size: 15px !important;
}

.ManualTimeAddition-module__font-s-16___JKvCV {
  font-size: 16px !important;
}

.ManualTimeAddition-module__font-s-18___fHwGC {
  font-size: 18px !important;
}

.ManualTimeAddition-module__font-s-20___H9fX0 {
  font-size: 20px !important;
}

.ManualTimeAddition-module__font-s-22___HdXVk {
  font-size: 22px !important;
}

.ManualTimeAddition-module__font-s-28___S0CDH {
  font-size: 28px !important;
}

.ManualTimeAddition-module__font-w-400___3zu6w {
  font-weight: 400 !important;
}

.ManualTimeAddition-module__font-w-500___VvCUK {
  font-weight: 500 !important;
}

.ManualTimeAddition-module__font-w-600___ujUU_ {
  font-weight: 600 !important;
}

.ManualTimeAddition-module__font-w-700___uUluB {
  font-weight: 700 !important;
}

.ManualTimeAddition-module__p-5___k3ZkQ {
  padding: 5px !important;
}

.ManualTimeAddition-module__p-12___koi9i {
  padding: 12px !important;
}

.ManualTimeAddition-module__p-16___LYlRC {
  padding: 16px !important;
}

.ManualTimeAddition-module__p-30___SnGTi {
  padding: 30px !important;
}

.ManualTimeAddition-module__p-b-0___NFu1v {
  padding-bottom: 0 !important;
}

.ManualTimeAddition-module__p-b-5___jaPyd {
  padding-bottom: 5px !important;
}

.ManualTimeAddition-module__p-b-10___fFFP0 {
  padding-bottom: 10px !important;
}

.ManualTimeAddition-module__p-b-12___ejYxC {
  padding-bottom: 12px !important;
}

.ManualTimeAddition-module__p-b-16___gWFZd {
  padding-bottom: 16px !important;
}

.ManualTimeAddition-module__p-b-18___ePFEI {
  padding-bottom: 18px !important;
}

.ManualTimeAddition-module__p-b-20___fetKe {
  padding-bottom: 20px !important;
}

.ManualTimeAddition-module__p-b-25___N34lL {
  padding-bottom: 25px !important;
}

.ManualTimeAddition-module__p-b-30___h7F9R {
  padding-bottom: 30px !important;
}

.ManualTimeAddition-module__p-b-50___w4fwe {
  padding-bottom: 50px !important;
}

.ManualTimeAddition-module__p-t-0___ButrA {
  padding-top: 0 !important;
}

.ManualTimeAddition-module__p-t-12___RDbDW {
  padding-top: 12px !important;
}

.ManualTimeAddition-module__p-t-16___rn47a {
  padding-top: 16px !important;
}

.ManualTimeAddition-module__p-t-18___GeZNi {
  padding-top: 18px !important;
}

.ManualTimeAddition-module__p-t-20___dB622 {
  padding-top: 20px !important;
}

.ManualTimeAddition-module__p-t-30___KoS4B {
  padding-top: 30px !important;
}

.ManualTimeAddition-module__p-t-40___LBqYQ {
  padding-top: 40px !important;
}

.ManualTimeAddition-module__p-t-50___t065U {
  padding-top: 50px !important;
}

.ManualTimeAddition-module__p-l-20___rt0U4 {
  padding-left: 20px !important;
}

.ManualTimeAddition-module__p-l-30___TVlvK {
  padding-left: 30px !important;
}

.ManualTimeAddition-module__p-l-40___P_6IK {
  padding-left: 40px !important;
}

.ManualTimeAddition-module__p-r-16___WjAs1 {
  padding-right: 16px !important;
}

.ManualTimeAddition-module__p-r-20___QVPwd {
  padding-right: 20px !important;
}

.ManualTimeAddition-module__p-r-30___BFalv {
  padding-right: 30px !important;
}

.ManualTimeAddition-module__p-r-50___zQkk4 {
  padding-right: 50px !important;
}

.ManualTimeAddition-module__p-r-60___tnEEF {
  padding-right: 60px !important;
}

.ManualTimeAddition-module__m-b-1___VZLOj {
  margin-bottom: 1px !important;
}

.ManualTimeAddition-module__m-b-2___vgqKX {
  margin-bottom: 2px !important;
}

.ManualTimeAddition-module__m-b-6____x4Im {
  margin-bottom: 6px !important;
}

.ManualTimeAddition-module__m-b-8___M219R {
  margin-bottom: 8px !important;
}

.ManualTimeAddition-module__m-b-10___q73Dz {
  margin-bottom: 10px !important;
}

.ManualTimeAddition-module__m-b-14___IiZn3 {
  margin-bottom: 14px !important;
}

.ManualTimeAddition-module__m-b-16___yXXXE {
  margin-bottom: 16px !important;
}

.ManualTimeAddition-module__m-b-20___YaDML {
  margin-bottom: 20px !important;
}

.ManualTimeAddition-module__m-b-22___c6Rck {
  margin-bottom: 22px !important;
}

.ManualTimeAddition-module__m-b-24___zFXfR {
  margin-bottom: 24px !important;
}

.ManualTimeAddition-module__m-b-30___eXXLY {
  margin-bottom: 30px !important;
}

.ManualTimeAddition-module__m-b-32___RPAq1 {
  margin-bottom: 32px !important;
}

.ManualTimeAddition-module__m-b-40___lp73u {
  margin-bottom: 40px !important;
}

.ManualTimeAddition-module__m-t-2___kaUeJ {
  margin-top: 2px !important;
}

.ManualTimeAddition-module__m-t-3___Si69L {
  margin-top: 3px !important;
}

.ManualTimeAddition-module__m-t-4___TbA2D {
  margin-top: 4px !important;
}

.ManualTimeAddition-module__m-t-5___xiNXV {
  margin-top: 5px !important;
}

.ManualTimeAddition-module__m-t-8___ftQWO {
  margin-top: 8px !important;
}

.ManualTimeAddition-module__m-t-10___JUBKJ {
  margin-top: 10px !important;
}

.ManualTimeAddition-module__m-t-15___thD7U {
  margin-top: 15px !important;
}

.ManualTimeAddition-module__m-t-16___oICW2 {
  margin-top: 16px !important;
}

.ManualTimeAddition-module__m-t-20___Mj4Vo {
  margin-top: 20px !important;
}

.ManualTimeAddition-module__m-t-22___bU6Dp {
  margin-top: 22px !important;
}

.ManualTimeAddition-module__m-t-30___jDN5r {
  margin-top: 30px !important;
}

.ManualTimeAddition-module__m-t-32___h6TzY {
  margin-top: 32px !important;
}

.ManualTimeAddition-module__m-l-auto___u4fNM {
  margin-left: auto !important;
}

.ManualTimeAddition-module__m-l-4___WOpOc {
  margin-left: 4px !important;
}

.ManualTimeAddition-module__m-l-5___W9sn4 {
  margin-left: 5px !important;
}

.ManualTimeAddition-module__m-l-6___BQ0BK {
  margin-left: 6px !important;
}

.ManualTimeAddition-module__m-l-8___Smiyc {
  margin-left: 8px !important;
}

.ManualTimeAddition-module__m-l-10___jFXpT {
  margin-left: 10px !important;
}

.ManualTimeAddition-module__m-l-16___ISdni {
  margin-left: 16px !important;
}

.ManualTimeAddition-module__m-l-20___eNCzP {
  margin-left: 20px !important;
}

.ManualTimeAddition-module__m-l-24___BJAHT {
  margin-left: 24px !important;
}

.ManualTimeAddition-module__m-l-30___D4Xc7 {
  margin-left: 30px !important;
}

.ManualTimeAddition-module__m-l-35___ky_E3 {
  margin-left: 35px !important;
}

.ManualTimeAddition-module__m-l-40___LGzNW {
  margin-left: 40px !important;
}

.ManualTimeAddition-module__m-r-8___I_K7O {
  margin-right: 8px !important;
}

.ManualTimeAddition-module__m-r-10___lyrHd {
  margin-right: 10px !important;
}

.ManualTimeAddition-module__m-r-16___uCcmU {
  margin-right: 16px !important;
}

.ManualTimeAddition-module__m-r-20___i_0i1 {
  margin-right: 20px !important;
}

.ManualTimeAddition-module__m-r-24___Nh9Ue {
  margin-right: 24px !important;
}

.ManualTimeAddition-module__m-r-30___i68ke {
  margin-right: 30px !important;
}

.ManualTimeAddition-module__m-r-40___w4Ek4 {
  margin-right: 40px !important;
}

.ManualTimeAddition-module__border-r-3___aZE9m {
  border-radius: 3px !important;
}

.ManualTimeAddition-module__border-r-4___pox0e {
  border-radius: 4px !important;
}

.ManualTimeAddition-module__border-r-6___Rf78T {
  border-radius: 6px !important;
}

.ManualTimeAddition-module__border-r-10___Rg4yp {
  border-radius: 10px !important;
}

.ManualTimeAddition-module__border-r-12___acrR4 {
  border-radius: 12px !important;
}

.ManualTimeAddition-module__border-r-16___Cq8zY {
  border-radius: 16px !important;
}

.ManualTimeAddition-module__border-r-50___CGaLw {
  border-radius: 50% !important;
}

.ManualTimeAddition-module__primary-border___XVD_j {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ManualTimeAddition-module__primary-border-b___wSef3 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ManualTimeAddition-module__primary-border-t___WLTJy {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ManualTimeAddition-module__primary-border-l___vXHtH {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ManualTimeAddition-module__primary-border-r___lzU71 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ManualTimeAddition-module__secondary-border___zJcGw {
  border: 1px solid #637768;
}

.ManualTimeAddition-module__secondary-border-b___FNHd0 {
  border-bottom: 1px solid #637768;
}

.ManualTimeAddition-module__secondary-border-t___CzUqJ {
  border-top: 1px solid #637768;
}

.ManualTimeAddition-module__secondary-border-l___TS4P_ {
  border-left: 1px solid #637768;
}

.ManualTimeAddition-module__secondary-border-r___yqEcn {
  border-right: 1px solid #637768;
}

.ManualTimeAddition-module__gap-0___PwvU4 {
  gap: 0 !important;
}

.ManualTimeAddition-module__gap-2___iOZMy {
  gap: 2px !important;
}

.ManualTimeAddition-module__gap-4___NmlYK {
  gap: 4px !important;
}

.ManualTimeAddition-module__gap-5___ATy_F {
  gap: 5px !important;
}

.ManualTimeAddition-module__gap-6___XJriP {
  gap: 6px !important;
}

.ManualTimeAddition-module__gap-8___gmzdC {
  gap: 8px !important;
}

.ManualTimeAddition-module__gap-10___oQs6c {
  gap: 10px !important;
}

.ManualTimeAddition-module__gap-12___TmtI0 {
  gap: 12px !important;
}

.ManualTimeAddition-module__gap-14___CaivY {
  gap: 14px !important;
}

.ManualTimeAddition-module__gap-16___yshCg {
  gap: 16px !important;
}

.ManualTimeAddition-module__gap-18___ZrGxw {
  gap: 18px !important;
}

.ManualTimeAddition-module__gap-20___pc5s8 {
  gap: 20px !important;
}

.ManualTimeAddition-module__gap-24___Upcry {
  gap: 24px !important;
}

.ManualTimeAddition-module__gap-26___g_j29 {
  gap: 26px !important;
}

.ManualTimeAddition-module__gap-30___dIBcY {
  gap: 30px !important;
}

.ManualTimeAddition-module__gap-32___i1qd_ {
  gap: 32px !important;
}

.ManualTimeAddition-module__gap-40___ufS5T {
  gap: 40px !important;
}

.ManualTimeAddition-module__gap-50___HlyTU {
  gap: 50px !important;
}

.ManualTimeAddition-module__flex-1___g8mFZ {
  flex: 1;
}

.ManualTimeAddition-module__flex-none___fJ3IA {
  flex: none !important;
}

.ManualTimeAddition-module__flex-column___SpDIO {
  display: flex;
  flex-direction: column !important;
}

.ManualTimeAddition-module__flex-row___dCSWr {
  display: flex;
  flex-direction: row !important;
}

.ManualTimeAddition-module__vertically-centered___hVhXI {
  display: flex;
  align-items: center !important;
}

.ManualTimeAddition-module__horizontally-centered___FAD9A {
  display: flex;
  justify-content: center !important;
}

.ManualTimeAddition-module__horizontally-end___mU5IC {
  display: flex;
  justify-content: end !important;
}

.ManualTimeAddition-module__vertically-start___KKqM2 {
  display: flex;
  align-items: start !important;
}

.ManualTimeAddition-module__space-between___xDxZE {
  display: flex;
  justify-content: space-between !important;
}

.ManualTimeAddition-module__flex-wrap___AzuC1 {
  flex-wrap: wrap !important;
}

.ManualTimeAddition-module__height-100___eQBNz {
  height: 100%;
}

.ManualTimeAddition-module__width-50___dFa0T {
  width: 50% !important;
}

.ManualTimeAddition-module__width-100___jS9C0 {
  width: 100%;
}

.ManualTimeAddition-module__cursor-pointer___j5vf5 {
  cursor: pointer;
}

.ManualTimeAddition-module__cursor-not-allowed___JTCPX {
  cursor: not-allowed !important;
}

.ManualTimeAddition-module__absolute-centered___NJR8z {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ManualTimeAddition-module__absolute___oUx8T {
  position: absolute;
}

.ManualTimeAddition-module__relative___FKaVj {
  position: relative;
}

.ManualTimeAddition-module__fixed___RQlSG {
  position: fixed;
}

.ManualTimeAddition-module__visible___U0eo0 {
  opacity: 1;
}

.ManualTimeAddition-module__invisible___lqmcf {
  opacity: 0;
}

.ManualTimeAddition-module__col-90___PFrSy {
  width: 90% !important;
}

.ManualTimeAddition-module__col-auto___hTQCm {
  width: auto !important;
}

.ManualTimeAddition-module__medical-tabs___jArz1 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ManualTimeAddition-module__medical-table-new___V9i4B {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ManualTimeAddition-module__medical-table-new___V9i4B:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ManualTimeAddition-module__medical-table-new___V9i4B::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ManualTimeAddition-module__medical-table-new___V9i4B::-webkit-scrollbar-track {
  display: none;
}
.ManualTimeAddition-module__medical-table-new___V9i4B.ManualTimeAddition-module__no-pagination___CHvUM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ManualTimeAddition-module__medical-table-new___V9i4B.ManualTimeAddition-module__no-pagination___CHvUM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ManualTimeAddition-module__medical-table-new___V9i4B.ManualTimeAddition-module__no-pagination___CHvUM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ManualTimeAddition-module__medical-table-new___V9i4B.ManualTimeAddition-module__no-pagination___CHvUM::-webkit-scrollbar-track {
  display: none;
}

.ManualTimeAddition-module__medical-table-empty___agOjc {
  padding: 14px 40px !important;
}

.ManualTimeAddition-module__icon-btn___wlyc9 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ManualTimeAddition-module__search-icon___sVunp {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ManualTimeAddition-module__disable-select___UxFQt {
  user-select: none;
}

.ManualTimeAddition-module__break-word___GC6Qm {
  word-break: break-word;
}

.ManualTimeAddition-module__popup-clear-btn___CagkJ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ManualTimeAddition-module__scroll-m-b-20___tZ_4o {
  scroll-margin-bottom: 20px;
}

.ManualTimeAddition-module__header___NQRBP {
  color: #375844;
  padding: 4px 0;
}

.ManualTimeAddition-module__subHeader___qaRLt {
  color: #375844;
}

.ManualTimeAddition-module__button___l_P6G > img {
  width: 18px;
  height: 18px;
}
.ManualTimeAddition-module__button___l_P6G > span {
  font-size: 14px !important;
}

.ManualTimeAddition-module__removeButton___Nm4UG {
  margin-bottom: 12px;
  align-self: end;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/LinkedConversationsModule/ManualTimeAddition/ManualTimeAddition.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA1pBE;EACE,WAAA;EACA,YAAA;AA6pBJ;AA1pBE;EACE,0BAAA;AA4pBJ;;AAxpBA;EACE,mBAAA;EACA,eAAA;AA2pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  color: get-color(greenNew, dark);\n  padding: 4px 0;\n}\n\n.subHeader {\n  color: get-color(greenNew, dark);\n}\n\n.button {\n  & > img {\n    width: 18px;\n    height: 18px;\n  }\n\n  & > span {\n    font-size: 14px !important;\n  }\n}\n\n.removeButton {\n  margin-bottom: 12px;\n  align-self: end;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ManualTimeAddition-module__font-s-10___RnjAl`,
	"fontS12": `ManualTimeAddition-module__font-s-12___C0yXL`,
	"fontS13": `ManualTimeAddition-module__font-s-13___z04K4`,
	"fontS14": `ManualTimeAddition-module__font-s-14___gs5Ge`,
	"fontS15": `ManualTimeAddition-module__font-s-15___QpJNi`,
	"fontS16": `ManualTimeAddition-module__font-s-16___JKvCV`,
	"fontS18": `ManualTimeAddition-module__font-s-18___fHwGC`,
	"fontS20": `ManualTimeAddition-module__font-s-20___H9fX0`,
	"fontS22": `ManualTimeAddition-module__font-s-22___HdXVk`,
	"fontS28": `ManualTimeAddition-module__font-s-28___S0CDH`,
	"fontW400": `ManualTimeAddition-module__font-w-400___3zu6w`,
	"fontW500": `ManualTimeAddition-module__font-w-500___VvCUK`,
	"fontW600": `ManualTimeAddition-module__font-w-600___ujUU_`,
	"fontW700": `ManualTimeAddition-module__font-w-700___uUluB`,
	"p5": `ManualTimeAddition-module__p-5___k3ZkQ`,
	"p12": `ManualTimeAddition-module__p-12___koi9i`,
	"p16": `ManualTimeAddition-module__p-16___LYlRC`,
	"p30": `ManualTimeAddition-module__p-30___SnGTi`,
	"pB0": `ManualTimeAddition-module__p-b-0___NFu1v`,
	"pB5": `ManualTimeAddition-module__p-b-5___jaPyd`,
	"pB10": `ManualTimeAddition-module__p-b-10___fFFP0`,
	"pB12": `ManualTimeAddition-module__p-b-12___ejYxC`,
	"pB16": `ManualTimeAddition-module__p-b-16___gWFZd`,
	"pB18": `ManualTimeAddition-module__p-b-18___ePFEI`,
	"pB20": `ManualTimeAddition-module__p-b-20___fetKe`,
	"pB25": `ManualTimeAddition-module__p-b-25___N34lL`,
	"pB30": `ManualTimeAddition-module__p-b-30___h7F9R`,
	"pB50": `ManualTimeAddition-module__p-b-50___w4fwe`,
	"pT0": `ManualTimeAddition-module__p-t-0___ButrA`,
	"pT12": `ManualTimeAddition-module__p-t-12___RDbDW`,
	"pT16": `ManualTimeAddition-module__p-t-16___rn47a`,
	"pT18": `ManualTimeAddition-module__p-t-18___GeZNi`,
	"pT20": `ManualTimeAddition-module__p-t-20___dB622`,
	"pT30": `ManualTimeAddition-module__p-t-30___KoS4B`,
	"pT40": `ManualTimeAddition-module__p-t-40___LBqYQ`,
	"pT50": `ManualTimeAddition-module__p-t-50___t065U`,
	"pL20": `ManualTimeAddition-module__p-l-20___rt0U4`,
	"pL30": `ManualTimeAddition-module__p-l-30___TVlvK`,
	"pL40": `ManualTimeAddition-module__p-l-40___P_6IK`,
	"pR16": `ManualTimeAddition-module__p-r-16___WjAs1`,
	"pR20": `ManualTimeAddition-module__p-r-20___QVPwd`,
	"pR30": `ManualTimeAddition-module__p-r-30___BFalv`,
	"pR50": `ManualTimeAddition-module__p-r-50___zQkk4`,
	"pR60": `ManualTimeAddition-module__p-r-60___tnEEF`,
	"mB1": `ManualTimeAddition-module__m-b-1___VZLOj`,
	"mB2": `ManualTimeAddition-module__m-b-2___vgqKX`,
	"mB6": `ManualTimeAddition-module__m-b-6____x4Im`,
	"mB8": `ManualTimeAddition-module__m-b-8___M219R`,
	"mB10": `ManualTimeAddition-module__m-b-10___q73Dz`,
	"mB14": `ManualTimeAddition-module__m-b-14___IiZn3`,
	"mB16": `ManualTimeAddition-module__m-b-16___yXXXE`,
	"mB20": `ManualTimeAddition-module__m-b-20___YaDML`,
	"mB22": `ManualTimeAddition-module__m-b-22___c6Rck`,
	"mB24": `ManualTimeAddition-module__m-b-24___zFXfR`,
	"mB30": `ManualTimeAddition-module__m-b-30___eXXLY`,
	"mB32": `ManualTimeAddition-module__m-b-32___RPAq1`,
	"mB40": `ManualTimeAddition-module__m-b-40___lp73u`,
	"mT2": `ManualTimeAddition-module__m-t-2___kaUeJ`,
	"mT3": `ManualTimeAddition-module__m-t-3___Si69L`,
	"mT4": `ManualTimeAddition-module__m-t-4___TbA2D`,
	"mT5": `ManualTimeAddition-module__m-t-5___xiNXV`,
	"mT8": `ManualTimeAddition-module__m-t-8___ftQWO`,
	"mT10": `ManualTimeAddition-module__m-t-10___JUBKJ`,
	"mT15": `ManualTimeAddition-module__m-t-15___thD7U`,
	"mT16": `ManualTimeAddition-module__m-t-16___oICW2`,
	"mT20": `ManualTimeAddition-module__m-t-20___Mj4Vo`,
	"mT22": `ManualTimeAddition-module__m-t-22___bU6Dp`,
	"mT30": `ManualTimeAddition-module__m-t-30___jDN5r`,
	"mT32": `ManualTimeAddition-module__m-t-32___h6TzY`,
	"mLAuto": `ManualTimeAddition-module__m-l-auto___u4fNM`,
	"mL4": `ManualTimeAddition-module__m-l-4___WOpOc`,
	"mL5": `ManualTimeAddition-module__m-l-5___W9sn4`,
	"mL6": `ManualTimeAddition-module__m-l-6___BQ0BK`,
	"mL8": `ManualTimeAddition-module__m-l-8___Smiyc`,
	"mL10": `ManualTimeAddition-module__m-l-10___jFXpT`,
	"mL16": `ManualTimeAddition-module__m-l-16___ISdni`,
	"mL20": `ManualTimeAddition-module__m-l-20___eNCzP`,
	"mL24": `ManualTimeAddition-module__m-l-24___BJAHT`,
	"mL30": `ManualTimeAddition-module__m-l-30___D4Xc7`,
	"mL35": `ManualTimeAddition-module__m-l-35___ky_E3`,
	"mL40": `ManualTimeAddition-module__m-l-40___LGzNW`,
	"mR8": `ManualTimeAddition-module__m-r-8___I_K7O`,
	"mR10": `ManualTimeAddition-module__m-r-10___lyrHd`,
	"mR16": `ManualTimeAddition-module__m-r-16___uCcmU`,
	"mR20": `ManualTimeAddition-module__m-r-20___i_0i1`,
	"mR24": `ManualTimeAddition-module__m-r-24___Nh9Ue`,
	"mR30": `ManualTimeAddition-module__m-r-30___i68ke`,
	"mR40": `ManualTimeAddition-module__m-r-40___w4Ek4`,
	"borderR3": `ManualTimeAddition-module__border-r-3___aZE9m`,
	"borderR4": `ManualTimeAddition-module__border-r-4___pox0e`,
	"borderR6": `ManualTimeAddition-module__border-r-6___Rf78T`,
	"borderR10": `ManualTimeAddition-module__border-r-10___Rg4yp`,
	"borderR12": `ManualTimeAddition-module__border-r-12___acrR4`,
	"borderR16": `ManualTimeAddition-module__border-r-16___Cq8zY`,
	"borderR50": `ManualTimeAddition-module__border-r-50___CGaLw`,
	"primaryBorder": `ManualTimeAddition-module__primary-border___XVD_j`,
	"primaryBorderB": `ManualTimeAddition-module__primary-border-b___wSef3`,
	"primaryBorderT": `ManualTimeAddition-module__primary-border-t___WLTJy`,
	"primaryBorderL": `ManualTimeAddition-module__primary-border-l___vXHtH`,
	"primaryBorderR": `ManualTimeAddition-module__primary-border-r___lzU71`,
	"secondaryBorder": `ManualTimeAddition-module__secondary-border___zJcGw`,
	"secondaryBorderB": `ManualTimeAddition-module__secondary-border-b___FNHd0`,
	"secondaryBorderT": `ManualTimeAddition-module__secondary-border-t___CzUqJ`,
	"secondaryBorderL": `ManualTimeAddition-module__secondary-border-l___TS4P_`,
	"secondaryBorderR": `ManualTimeAddition-module__secondary-border-r___yqEcn`,
	"gap0": `ManualTimeAddition-module__gap-0___PwvU4`,
	"gap2": `ManualTimeAddition-module__gap-2___iOZMy`,
	"gap4": `ManualTimeAddition-module__gap-4___NmlYK`,
	"gap5": `ManualTimeAddition-module__gap-5___ATy_F`,
	"gap6": `ManualTimeAddition-module__gap-6___XJriP`,
	"gap8": `ManualTimeAddition-module__gap-8___gmzdC`,
	"gap10": `ManualTimeAddition-module__gap-10___oQs6c`,
	"gap12": `ManualTimeAddition-module__gap-12___TmtI0`,
	"gap14": `ManualTimeAddition-module__gap-14___CaivY`,
	"gap16": `ManualTimeAddition-module__gap-16___yshCg`,
	"gap18": `ManualTimeAddition-module__gap-18___ZrGxw`,
	"gap20": `ManualTimeAddition-module__gap-20___pc5s8`,
	"gap24": `ManualTimeAddition-module__gap-24___Upcry`,
	"gap26": `ManualTimeAddition-module__gap-26___g_j29`,
	"gap30": `ManualTimeAddition-module__gap-30___dIBcY`,
	"gap32": `ManualTimeAddition-module__gap-32___i1qd_`,
	"gap40": `ManualTimeAddition-module__gap-40___ufS5T`,
	"gap50": `ManualTimeAddition-module__gap-50___HlyTU`,
	"flex1": `ManualTimeAddition-module__flex-1___g8mFZ`,
	"flexNone": `ManualTimeAddition-module__flex-none___fJ3IA`,
	"flexColumn": `ManualTimeAddition-module__flex-column___SpDIO`,
	"flexRow": `ManualTimeAddition-module__flex-row___dCSWr`,
	"verticallyCentered": `ManualTimeAddition-module__vertically-centered___hVhXI`,
	"horizontallyCentered": `ManualTimeAddition-module__horizontally-centered___FAD9A`,
	"horizontallyEnd": `ManualTimeAddition-module__horizontally-end___mU5IC`,
	"verticallyStart": `ManualTimeAddition-module__vertically-start___KKqM2`,
	"spaceBetween": `ManualTimeAddition-module__space-between___xDxZE`,
	"flexWrap": `ManualTimeAddition-module__flex-wrap___AzuC1`,
	"height100": `ManualTimeAddition-module__height-100___eQBNz`,
	"width50": `ManualTimeAddition-module__width-50___dFa0T`,
	"width100": `ManualTimeAddition-module__width-100___jS9C0`,
	"cursorPointer": `ManualTimeAddition-module__cursor-pointer___j5vf5`,
	"cursorNotAllowed": `ManualTimeAddition-module__cursor-not-allowed___JTCPX`,
	"absoluteCentered": `ManualTimeAddition-module__absolute-centered___NJR8z`,
	"absolute": `ManualTimeAddition-module__absolute___oUx8T`,
	"relative": `ManualTimeAddition-module__relative___FKaVj`,
	"fixed": `ManualTimeAddition-module__fixed___RQlSG`,
	"visible": `ManualTimeAddition-module__visible___U0eo0`,
	"invisible": `ManualTimeAddition-module__invisible___lqmcf`,
	"col90": `ManualTimeAddition-module__col-90___PFrSy`,
	"colAuto": `ManualTimeAddition-module__col-auto___hTQCm`,
	"medicalTabs": `ManualTimeAddition-module__medical-tabs___jArz1`,
	"medicalTableNew": `ManualTimeAddition-module__medical-table-new___V9i4B`,
	"noPagination": `ManualTimeAddition-module__no-pagination___CHvUM`,
	"medicalTableEmpty": `ManualTimeAddition-module__medical-table-empty___agOjc`,
	"iconBtn": `ManualTimeAddition-module__icon-btn___wlyc9`,
	"searchIcon": `ManualTimeAddition-module__search-icon___sVunp`,
	"disableSelect": `ManualTimeAddition-module__disable-select___UxFQt`,
	"breakWord": `ManualTimeAddition-module__break-word___GC6Qm`,
	"popupClearBtn": `ManualTimeAddition-module__popup-clear-btn___CagkJ`,
	"scrollMB20": `ManualTimeAddition-module__scroll-m-b-20___tZ_4o`,
	"header": `ManualTimeAddition-module__header___NQRBP`,
	"subHeader": `ManualTimeAddition-module__subHeader___qaRLt`,
	"button": `ManualTimeAddition-module__button___l_P6G`,
	"removeButton": `ManualTimeAddition-module__removeButton___Nm4UG`
};
module.exports = ___CSS_LOADER_EXPORT___;
